import React, { Component } from 'react';
import Seed from './Seed';
import './App.css';
import ModalView from "./ModalView";

class App extends Component {

	constructor(props) {
	  super(props);
	  this.state = {
		  projects: Seed.projects,
		  isModalVisible: false,
		  getClickedProjectUrl: ''
	  };
	}

	getPreviewImages = (r) => {
		return r.keys().map(r);
	};

	openProjectUrl = (e, url) => {
		this.setState({getClickedProjectUrl: url, isModalVisible:true});
	};

	modalOnOff = () => {
		this.setState(prevState => ({ isModalVisible: !prevState.isModalVisible }));
	};

  render() {
		console.log('Rendering: App');
	  return (
			<React.Fragment>
				<section className='hero is-medium'>
					<div className='hero-body'>
						<div className='container'>
							<p id='my-name'>FELIPE<br/>PADILLA</p>
							<p id='my-title'>Digital Advertisement and Media Developer</p>
							<p id='my-intro'>Hello. I’m a Front End Developer based in LA. During my over 10 years of experience I’ve had the opportunity to work on projects for: Volkswagen, Nissan, Playstation, and Sprint among others. Interested in working together?
								<a className='bold' href='https://www.linkedin.com/in/padillafelipe/'> Let’s get in touch.</a></p>
						</div>
					</div>
				</section>
				<section className='section'>
					<div className='container'>
						<div className="tile is-ancestor">
							{this.state.projects.map((item, index) =>{
								return (
									<div key={index} className="tile is-4 is-parent">
										<div className="tile is-child box is-shadowless is-radiusless" onClick={(e) => {this.openProjectUrl(e, item.url)}}>
											<figure className='image padding-tile'><img src={item.projectImageUrl} alt=""/></figure>
										</div>
									</div>
								)
							})}
						</div>
					</div>
				</section>
				{this.state.isModalVisible ? (
					<ModalView renderModal={this.modalOnOff} isModalVisible={this.state.isModalVisible} url={this.state.getClickedProjectUrl}/>
				):(
					null
				)}
			</React.Fragment>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js